import React, { createContext, useContext, useEffect, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import * as actionsDonation from '../../../../_redux/donation/donationAction';
import * as actionsDonatur from '../../../../../Donatur/_redux/donatur/donaturAction'
import * as reqDonasi from '../../../../_redux/donation/donationCrud';
import { toast } from 'react-toastify';
import { toastOption, copyValue } from '../../../../../../../_metronic/_helpers';
import { v4 as uuidv4 } from 'uuid';
import moment from 'moment';
import { CircularProgress, Backdrop } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles';

const DonationDetailUIContext = createContext();

export function useDonationDetailUIContext() {
    return useContext(DonationDetailUIContext);
}

export const DonationDetailUIConsumer = DonationDetailUIContext.Consumer;

export function DonationDetailUIProvider({
    currentDonationId,
    children,
    history,
    btnRef,
    donationUIEvent
}) {

    const dispatch = useDispatch();
    // get Donation Redux State
    const { currentState, errorDonation } = useSelector(
        (state) => ({ currentState: state.donations, errorDonations: state.donations.error }),
        shallowEqual,
    );
    const { reconcileState, errorReconcile } = useSelector(
        (state) => ({ reconcileState: state.reconcile, errorReconcile: state.reconcile.error }),
        shallowEqual,
    );

    const { reconcileData } = reconcileState

    if (errorDonation) {
        toast.error(errorDonation, toastOption)
    }
    if (errorReconcile) {
        toast.error(errorReconcile, toastOption)
    }

    const initDonatur = {
        uuid: undefined,
        donor_id: undefined,
        name: undefined,
        email: undefined,
        hp: undefined,
        address: undefined,
    };

    // Donatur Data State
    const [donatur, setDonatur] = useState(initDonatur);
    const [donation, setDonation] = useState([]);
    const [donationItem, setDonationItem] = useState([]);
    const [donationLog, setDonationLog] = useState([]);
    const [trxDate, setTrxDate] = useState(moment().format('YYYY-MM-DD'));
    const [statusPayment, setStatusPayment] = useState('')
    const [totalAmount, setTotalAmount] = useState('')
    let donation_items = []
    // console.log(reconcileData);


    const fetchDonationData = () => {
        setDonationItem([]);
        setDonationLog([]);

        // setDonation(reconcileData.donation_payment_items)


    }

    useEffect(() => {
        setDonationItem([])
        // reconcileData && (
        //     reconcileData.donation_payment_items.forEach(row => {
        //         let value = {
        //             uuid: row.uuid,
        //             donation_uuid: row.donation_uuid,
        //             type: row.type,
        //             goods_type: row.goods_type,
        //             goods_name: row.goods_name,
        //             goods_qty: row.goods_qty,
        //             amount: row.amount,
        //             name_1: row.name_1,
        //             name_2: row.name_2,
        //             name_3: row.name_3,
        //             name_4: row.name_4,
        //             name_5: row.name_5,
        //             name_6: row.name_6,
        //             name_7: row.name_7,
        //             tipe_kurban: row.tipe_kurban !== null ? row.tipe_kurban : null,
        //             thk_livestock_uuid: row.thk_livestock_uuid,
        //             thk_livestock_name: row.thk_livestock_name,
        //             program_uuid: row.program_uuid,
        //             program_name: row.program_name !== null ? row.program_name : null,
        //             project_uuid: row.project_uuid,
        //             project_name: row.project_name !== null ? row.project_name : null,
        //             is_letter: row.is_letter !== null ? row.is_letter : null
        //         };
        //         // Simpan ke dalam temporary
        //         setDonationItem((donationItem) => [...donationItem, value]);


        //         // Jika ada id donatur nya maka lakukan request data donatur

        //     })
        // )
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [reconcileData]);

    useEffect(() => {
        if (currentDonationId) {
            fetchDonationData();

        } else {
            setDonatur(initDonatur);
            setDonationItem([]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentDonationId]);

    // New Function Header Donation
    const [showDonatur, setShowDonatur] = useState(false);

    const openDonatur = () => {
        setShowDonatur(true);
    };

    const closeDonatur = () => {
        setShowDonatur(false);
    };

    const downloadReport = () => {
        if (donation) {
            window.open(donation.url_print)
        }
    }

    const setDonorValue = (data) => {
        setDonatur({
            uuid: data.uuid,
            donor_id: data.donor_id,
            name: data.name,
            email: data.email,
            hp: data.hp,
            address: data.address,
        });
    }

    // // Selected Current Donation
    // const donaturSelect = (data) => {
    //     // Jika tipe bukan input donasi maka lakukan langsung update data donaturnya
    //     if (currentDonationId) {
    //         let donaturData = {
    //             donation_uuid: currentDonationId,
    //             donor_uuid: data.uuid,
    //         };

    //         reqDonasi.updateDonatur([donaturData]).then(response => {
    //             if (response) {
    //                 toast.success('Donatur berhasil diperbarui', toastOption);
    //                 fetchDonationData();
    //                 setDonorValue(data)
    //             }
    //         }).catch(error => {
    //             toast.error(error.response.data.message, toastOption);
    //         })
    //     } else {
    //         setDonorValue(data)
    //     }
    //     setShowDonatur(false);
    // };

    const changeTrxDate = (event) => {
        setTrxDate(event.target.value);
    };

    const initItemData = {
        uuid: undefined,
        donation_uuid: currentDonationId ? currentDonationId : undefined,
        type: undefined,
        amount: '',
        name_1: donatur.uuid ? donatur.name : '',
        name_2: '',
        name_3: '',
        name_4: '',
        name_5: '',
        name_6: '',
        name_7: '',
        tipe_kurban: '',
        thk_livestock_uuid: undefined,
        thk_livestock_name: '',
        program_uuid: undefined,
        program_name: '',
        project_uuid: undefined,
        project_name: '',
        is_letter: 'false'
    };

    // Fungsi dibawah untuk edit donation Item
    const [showDialog, setShowDialog] = useState(false); // State show TRUE/FALSE Modal
    const [itemData, setItemData] = useState(initItemData); // Temporary State donation Item

    const openAddItem = () => {
        setItemData(initItemData);
        setShowDialog(true);
    };

    const openEditItem = (id) => {

        let obj = donationItem.find(function (key) {
            return key.uuid === id;
        });

        setItemData({
            uuid: obj.uuid,
            donation_uuid: obj.donation_uuid,
            type: obj.type,
            amount: obj.amount,
            name_1: obj.name_1,
            name_2: obj.name_2,
            name_3: obj.name_3,
            name_4: obj.name_4,
            name_5: obj.name_5,
            name_6: obj.name_6,
            name_7: obj.name_7,
            tipe_kurban: obj.tipe_kurban,
            thk_livestock_uuid: obj.thk_livestock_uuid,
            thk_livestock_name: obj.thk_livestock_name,
            program_uuid: obj.program_uuid,
            program_name: obj.program_name,
            project_uuid: obj.project_uuid,
            project_name: obj.project_name,
        });

        setShowDialog(true);
    };

    const closeDialogItem = () => {
        setShowDialog(false);
    };

    const removeItem = (id) => {
        const items = donationItem.filter(key => key.uuid !== id);
        setDonationItem(items);
    };

    // Fungsi Simpan donation Item Create/Update
    const saveDonationItem = (value) => {
        // if (!donatur.uuid) {
        //     return toast.error('Donatur wajib diisi', toastOption)
        // }
        const nameKurban = ['name_2', 'name_3', 'name_4', 'name_5', 'name_6', 'name_7', 'thk_livestock_uuid', 'thk_livestock_name']
        const other = ['program_uuid', 'program_name', 'project_uuid', 'project_name']
        if (!value.uuid) {
            // Jika tidak ditemukan UUID maka buat Item Baru
            value.uuid = uuidv4(); // Generate UUID Donation_item
            if (value.type !== 'KURBAN') {
                const filterValue = Object.fromEntries(
                    Object.entries(value).filter(([key, value]) => !nameKurban.includes(key))
                )
                setDonationItem(donationItem => [...donationItem, filterValue]);
            } else {
                const filterValue = Object.fromEntries(
                    Object.entries(value).filter(([key, value]) => !other.includes(key))
                )
                setDonationItem(donationItem => [...donationItem, filterValue]);
            }
        } else {
            // Jika ditemukan uuid item maka update item nya
            const newItem = donationItem;
            var index = newItem.findIndex(i => i.uuid === value.uuid);
            newItem.splice(index, 1, value);
        }
        setShowDialog(false);
    };

    // backdrop loading
    const [isSimpanLoading, setIsSimpanLoading] = useState(false)
    const useStyles = makeStyles((theme) => ({
        backdrop: {
            zIndex: theme.zIndex.drawer + 1,
            color: '#000000',
        },
    }));
    const classes = useStyles();
    // ACTION KE API DONATION
    // Fungsi untuk simpan transaksi donasi ke database/API
    const storeDonationItem = (value) => {
        setIsSimpanLoading(true)

        let { edc_type, edc_trans_id, edc_amount, cash_amount, mitra_amount, mitra_trans_id } = value;

        if (!donatur.uuid) {
            return toast.error('Donatur wajib diisi', toastOption)
        }
        if (donationItem.length < 1) {
            return toast.error('Item Donasi wajib diisi', toastOption)
        }
        if (statusPayment === "TUNAI") {
            cash_amount = copyValue(totalAmount)
        }
        if (statusPayment === "EDC") {
            edc_amount = copyValue(totalAmount)
        }
        if (statusPayment === "MITRA KONTER") {
            mitra_amount = copyValue(totalAmount)
        }

        if (statusPayment === '' && !currentDonationId) {
            return toast.error('Jenis Pembayaran wajib diisi', toastOption)
        }
        if (!currentDonationId) {
            let donationData = {
                donor_uuid: donatur.uuid,
                trx_date: trxDate, // Change this data
                payment_cash: Number(cash_amount),
                payment_edc: Number(edc_amount),
                payment_edc_provider: edc_type,
                payment_edc_trans_id: edc_trans_id,
                donation_item: donationItem,
                payment_counter_partner: Number(mitra_amount),
                payment_counter_partner_ref_id: mitra_trans_id
            };

            dispatch(actionsDonation.createDonation(donationData)).then(response => {
                if (response) {
                    setDonatur(initDonatur);
                    setDonationItem([]);
                    toast.success(response.message, toastOption);
                    // console.log(response);
                    history.push(`/donasi/${response.data.uuid}/detail`);
                    // history.push('/donasi/counter/list');
                }
                setIsSimpanLoading(false)

            });

        } else {
            dispatch(actionsDonation.updateDonationItem(donationItem, currentDonationId)).then(response => {
                if (response) {
                    toast.success(response.message, toastOption);
                    console.log('masuk');
                }
                // setIsSimpanLoading(false)
                // console.log(isSimpanLoading);
                setIsSimpanLoading(false)


            });
        }
        // setIsSimpanLoading(false)

    };

    const value = {
        donationId: currentDonationId, // UUID Donation Header
        showDialog, // Modal Dialog Display TRUE/FALSE
        itemData, // Current Donation Item Data only 1 row Item Not ALL
        donationItem, // Current all donation ITEM TEMPORARY / SHOW IN TABLE
        openAddItem,
        openEditItem,
        removeItem,
        closeDialogItem,
        saveDonationItem, // action update current item
        storeDonationItem, // action Send Data to API
        showDonatur,
        openDonatur,
        closeDonatur,
        // donaturSelect,
        donation,
        donatur,
        donationLog,
        changeTrxDate,
        setStatusPayment,
        setTotalAmount,
        setDonationItem
        // openNewDonatur: donationUIEvent.newDonaturButtonClick
    };

    return (
        <>
            <DonationDetailUIContext.Provider value={value}>
                <button style={{ display: 'none' }} onClick={downloadReport} ref={btnRef}></button>
                {children}
            </DonationDetailUIContext.Provider>
            <div>
                <Backdrop className={classes.backdrop} open={isSimpanLoading}>
                    <CircularProgress color="inherit" />
                </Backdrop>
            </div>
        </>
    );
}
